import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicMenusItemsApi extends BaseModulePublicApi {
  basePath = 'menus/';


  constructor(domain: string, menu_id: string) {
    super(domain);
    this.basePath = `menus/${menu_id}/items`;
  }
  updateMenuId(id: string) {
    this.basePath = `menus/${id}/items`;
  }
};